<template>
    <div>
        <Layout>
            <div class="row form__common--center">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header d-flex" style="gap: 0.5rem">
                            <h3 class="mb-0 title--screen">LP検索</h3>
                            <div class="ml-auto">
                                <ButtonActiveFilter :active.sync="isActive" />
                            </div>
                        </div>

                        <div v-if="isActive" class="card-body position-relative">
                            <div class="row justify-content-center">
                                <div class="col-sm-6 position-static">
                                    <form class="needs-validation" autocomplete="off">
                                        <div v-if="checkShowFilter" class="row form-group">
                                            <div class="col-sm-12">
                                                <KeyWordTag :config="configKeyword" class="" />
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div class="form-group row">
                                                <label class="col-sm-3" for="validationCustom05">{{ $t('landingPage.list.nameCampaign') }}</label>
                                                <div class="col-sm-9">
                                                    <InputText
                                                        :model.sync="formSearch.campaign_name"
                                                        :config="{
                                                            error: false
                                                        }"
                                                    />
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-sm-3" for="validationCustom05">{{ $t('landingPage.list.nameLandingPage') }}</label>
                                                <div class="col-sm-9">
                                                    <InputText
                                                        :model.sync="formSearch.name"
                                                        :config="{
                                                            error: false
                                                        }"
                                                    />
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-sm-3" for="validationCustom05">{{ $t('landingPage.list.lpID') }}</label>
                                                <div class="col-sm-9">
                                                    <InputText
                                                        :model.sync="formSearch.id"
                                                        :config="{
                                                            error: false
                                                        }"
                                                    />
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-sm-3" for="validationCustom05">{{
                                                    $t('landingPage.list.businessAssistant')
                                                }}</label>
                                                <div class="col-sm-9">
                                                    <Multiselect
                                                        :id="`select-formSearch-sale_staff`"
                                                        :value.sync="formSearch.filters.business_pic"
                                                        :options="listSaleStaff"
                                                        :config="{
                                                            trackBy: 'id',
                                                            label: 'name',
                                                            error: false,
                                                            isRemove: false,
                                                            loading: false
                                                        }"
                                                    />
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label class="col-sm-3 text-nowrap">{{ $t('landingPage.settingBasic.businessAssistant') }} </label>
                                                <div class="col-sm-9">
                                                    <Multiselect
                                                        :id="`select-sale_staff`"
                                                        :value.sync="formSearch.filters.instruction_pic"
                                                        :options="listDataMasterSaleEmploy"
                                                        :config="{ trackBy: 'id', label: 'name', isRemove: false, error: false }"
                                                    />
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label class="col-sm-3 text-nowrap">{{ $t('landingPage.settingBasic.status') }} </label>
                                                <div class="col-sm-9">
                                                    <div class="d-flex flex-wrap">
                                                        <div v-for="item in STATUS_SETTING_BASIC" :key="item.id + 's'">
                                                            <InputRadio
                                                                class="mr-4"
                                                                :model.sync="formSearch.filters.status"
                                                                :name="`status_basic_setting`"
                                                                :id="`status_basic_setting-${item.id}`"
                                                                :value="item.id"
                                                                :label="item.value"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label class="col-sm-3" for="validationCustom05">{{ $t('landingPage.list.startDateCP') }}</label>
                                                <div class="col-sm-9">
                                                    <div class="d-flex align-items-center flex-wrap-reverse mb-2">
                                                        <DateNormal :full_date.sync="formSearch.from_date.campaign_start_date"> </DateNormal>
                                                        <p class="mb-0">から</p>
                                                    </div>
                                                    <div class="d-flex align-items-center flex-wrap-reverse mb-2">
                                                        <DateNormal :full_date.sync="formSearch.to_date.campaign_start_date"> </DateNormal>
                                                        <p class="mb-0">まで</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-sm-3" for="validationCustom05">{{ $t('landingPage.list.endDateCP') }}</label>
                                                <div class="col-sm-9">
                                                    <div class="d-flex align-items-center flex-wrap-reverse mb-2">
                                                        <DateNormal :full_date.sync="formSearch.from_date.campaign_end_date"> </DateNormal>
                                                        <p class="mb-0">から</p>
                                                    </div>
                                                    <div class="d-flex align-items-center flex-wrap-reverse mb-2">
                                                        <DateNormal :full_date.sync="formSearch.to_date.campaign_end_date"> </DateNormal>
                                                        <p class="mb-0">まで</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-sm-3" for="validationCustom05">{{ $t('landingPage.list.startDateLP') }}</label>
                                                <div class="col-sm-9">
                                                    <div class="d-flex align-items-center flex-wrap-reverse mb-2">
                                                        <DateNormal :full_date.sync="formSearch.from_date.lp_start_date"> </DateNormal>
                                                        <p class="mb-0">から</p>
                                                    </div>
                                                    <div class="d-flex align-items-center flex-wrap-reverse mb-2">
                                                        <DateNormal :full_date.sync="formSearch.to_date.lp_start_date"> </DateNormal>
                                                        <p class="mb-0">まで</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-sm-3" for="validationCustom05">{{ $t('landingPage.list.endDateLP') }}</label>
                                                <div class="col-sm-9">
                                                    <div class="d-flex align-items-center flex-wrap-reverse mb-2">
                                                        <DateNormal :full_date.sync="formSearch.from_date.lp_end_date"> </DateNormal>
                                                        <p class="mb-0">から</p>
                                                    </div>
                                                    <div class="d-flex align-items-center flex-wrap-reverse mb-2">
                                                        <DateNormal :full_date.sync="formSearch.to_date.lp_end_date"> </DateNormal>
                                                        <p class="mb-0">まで</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="text-center mt-4">
                                            <button type="button" @click="clear()" class="btn btn-common btn-outline-primary" style="width: 100px">
                                                <i class="ri-restart-line"></i>クリア
                                            </button>
                                            <button type="button" @click="search()" class="btn btn-common btn-primary ml-3" style="width: 100px">
                                                <i class="ri-search-line"></i>検索
                                            </button>
                                            <button type="button" @click="handleShowFilter" class="btn btn-common filter btn-outline-primary">
                                                <i class="ri-equalizer-line"></i>絞り込み条件を表示
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header">
                            <h3 class="mb-0 title--screen">
                                LP検索結果 <span>件数（{{ configPage.total }})</span>
                            </h3>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-6"></div>
                                <div class="col-sm-6">
                                    <div class="pagination__items text-right">
                                        <span class="pagination__items__label mr-4"> {{ configPage.total }} 件中 {{ from }}-{{ to }} 件表示 </span>
                                        <span>表示件数</span>
                                        <select v-model="configPage.limit" class="pagination__items__select ml-2" @change="onChange">
                                            <option v-for="value in perPageList" :key="value" :label="value + '件'" :value="value"></option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div v-if="listDataTable.length > 0 && !isLoading" class="list-landingpage mt-5">
                                    <div class="grid-container">
                                        <div class="grid-item" v-for="(itemLP, idx) in listDataTable" :key="`lp-${idx}`">
                                            <Transition name="slide-fade__table--list" appear :key="idx">
                                                <div class="card box-lp">
                                                    <div class="first__view mb-3">
                                                        <div v-if="itemLP?.first_view?.image">
                                                            <img
                                                                :src="itemLP?.first_view?.image?.path"
                                                                style="width: 100%; height: 100%; object-fit: contain"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div v-else style="background-color: #cccccc47; height: 100%"></div>
                                                    </div>
                                                    <div class="card-body">
                                                        <h5 class="text-truncate">{{ itemLP?.name ?? '' }}</h5>
                                                        <div style="height: 4.5rem" class="card-text pb-5">
                                                            <h6 class="card-title text-truncate">{{ itemLP?.campaign?.name ?? '' }}</h6>
                                                            <p v-if="itemLP?.lp_start_date && itemLP?.lp_end_date">
                                                                {{ formatDateCommon(itemLP?.lp_start_date, 'dateTimeJP') ?? '' }} -
                                                                {{ formatDateCommon(itemLP?.lp_end_date, 'dateTimeJP') ?? '' }}
                                                            </p>
                                                        </div>
                                                        <div class="d-flex flex-wrap" style="gap: 6px">
                                                            <a
                                                                href="javascript:void(0)"
                                                                class="btn btn-common-sml btn-info text-nowrap"
                                                                @click="handleGoTo('/landing-page/view', itemLP)"
                                                                ><i class="ri-file-list-2-line"></i>{{ $t('btn.detail') }}</a
                                                            >
                                                            <a
                                                                v-if="checkPermission('landing_page.edit')"
                                                                href="javascript:void(0)"
                                                                class="btn btn-common-sml btn-primary text-nowrap"
                                                                @click="handleGoTo('/landing-page/edit', itemLP)"
                                                                ><i class="ri-edit-box-line"></i>{{ $t('btn.edit') }}</a
                                                            >
                                                            <button
                                                                v-if="itemLP?.is_first_update"
                                                                type="button"
                                                                class="btn btn-only-icon-sml btn-outline-warning text-nowrap"
                                                                :disabled="itemLP.status === 1"
                                                                @click="onHandlePublicPage(itemLP)"
                                                            >
                                                                <i class="ri-global-line"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Transition>
                                        </div>
                                    </div>
                                </div>
                                <div v-else-if="isLoading">
                                    <div class="d-flex justify-content-center">
                                        <LoadingIcon />
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="d-flex justify-content-center">
                                        {{ $t('notificationCommon.searchEmpty') }}
                                    </div>
                                </div>
                            </div>

                            <Pagination
                                v-if="configPage.total && listDataTable.length > 0 && !isLoading"
                                :total="configPage.total"
                                :page.sync="configPage.page"
                                :per-page="configPage.limit"
                                @changePage="handleChangePage"
                            ></Pagination>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import DateNormal from '@/components/DateCustoms/DateNormal/main.vue';
import KeyWordTag from '@/components/KeywordTag/main.vue';
import LoadingIcon from '@/components/Loading/main.vue';
import Pagination from '@/components/Pagination/main.vue';
import Multiselect from '@/components/Multiselect/main.vue';
import ButtonActiveFilter from '@/components/ButtonColFilter/main.vue';
import { checkPermission } from '@/utils/handlers';

import { configs, STATUS_FORM, initFormSearch, STATUS_SETTING_BASIC } from './constants';
import { InputText, InputRadio } from '@/components/Input';
import { masterMethods, landingPageMethods, managerFormMethods } from '@/state/helpers';
import { formatDateCommon } from '@/utils/format';
import { renderLineBreaks } from '@/utils/format';
import { cloneDeep } from 'lodash';

export default {
    name: 'LandingPage',
    page: {
        title: 'キャンペーン一覧',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        Layout,
        DateNormal,
        InputText,
        KeyWordTag,
        LoadingIcon,
        Pagination,
        Multiselect,
        InputRadio,
        ButtonActiveFilter
    },
    beforeRouteEnter(to, from, next) {
        if (!checkPermission('landing_page.view')) {
            next({ name: 'errorPage' });
        }
        next();
    },
    data() {
        return {
            configPage: configs.configPage,
            statusForm: STATUS_FORM,
            STATUS_SETTING_BASIC: STATUS_SETTING_BASIC,
            formSearch: initFormSearch(),
            listDataTable: [],
            listSaleStaff: [],
            listDataMasterSaleEmploy: [],
            perPageList: [10, 30, 50],
            configKeyword: {
                arrayTag: [],
                placeholder: this.$t('landingPage.list.placeholderSearch'),
                isShowLable: true,
                removeOnDelete: true
            },
            isLoading: false,
            checkShowFilter: true,
            isActive: true,
            listCustomDomains: []
        };
    },
    computed: {
        from: function () {
            return (this.configPage.page - 1) * this.configPage.limit + 1;
        },
        to: function () {
            let to = this.configPage.page * this.configPage.limit;
            return to > this.configPage.total ? this.configPage.total : to;
        }
    },
    methods: {
        checkPermission,
        ...masterMethods,
        ...landingPageMethods,
        ...managerFormMethods,
        renderLineBreaks,

        getQueryString() {
            let query = [`page=${this.configPage.page}`, `limit=${this.configPage.limit}`, `sorts[id]=desc`];
            let copyForm = cloneDeep(this.formSearch);
            copyForm.filters.instruction_pic = copyForm.filters.instruction_pic?.id ?? '';
            copyForm.filters.business_pic = copyForm.filters.business_pic?.id ?? '';

            if (copyForm.has) {
                for (const [key, value] of Object.entries(copyForm.has)) {
                    if (key && value) query.push(`has[${key}]=${value}`);
                }
            }

            if (this.checkShowFilter) {
                if (this.configKeyword.arrayTag.length > 0) {
                    query.push(`q=${this.configKeyword.arrayTag.toString()}`);
                }
            } else {
                if (copyForm) {
                    for (const [key, value] of Object.entries(copyForm)) {
                        if (key && value) {
                            if (['from_date', 'to_date'].includes(key)) {
                                if (key === 'from_date') {
                                    let from_date = Object.assign({}, copyForm.from_date);
                                    for (const [key, value] of Object.entries(from_date)) {
                                        if (key && value) query.push(`from[${key}]=${value}`);
                                    }
                                }
                                if (key === 'to_date') {
                                    let to_date = Object.assign({}, copyForm.to_date);
                                    for (const [key, value] of Object.entries(to_date)) {
                                        if (key && value) query.push(`to[${key}]=${value}`);
                                    }
                                }
                            } else {
                                if (key === 'filters') {
                                    for (const [keyF, valueF] of Object.entries(copyForm[key])) {
                                        if (keyF && valueF) query.push(`filters[${keyF}]=${encodeURIComponent(valueF)}`);
                                    }
                                } else {
                                    query.push(`search[${key}]=${encodeURIComponent(value)}`);
                                }
                            }
                        }
                    }
                }
            }
            return query.join('&');
        },

        async getList() {
            let query = this.getQueryString();
            this.isLoading = true;
            try {
                const data = await this.getListLandingPage(query);
                this.listDataTable = data.data;
                this.configPage.total = data._metadata.total;
                this.configPage.limit = data._metadata.limit * 1;
                if (!this.listDataTable.length && this.configPage.page !== 1) {
                    this.configPage.page = 1;
                    this.getList();
                } else {
                    this.isLoading = false;
                }
            } catch (error) {
                console.log('error', error);
            }
        },

        async getListCommonUser() {
            try {
                const dataRes = await this.listMaster('campaign/common-user');
                this.listSaleStaff = dataRes['admin_and_instructor'];
                this.listDataMasterSaleEmploy = dataRes['sale'];
            } catch (error) {
                console.log('error', error);
            }
        },

        clear() {
            this.configKeyword.arrayTag = [];
            this.formSearch = initFormSearch();
            this.getList();
        },
        search() {
            this.getList();
        },

        handleGoTo(url, row) {
            this.$router.push({ path: url, query: { id: row.id } });
        },

        getLpPublicUrl(objLP) {
            const domainLP = process.env.VUE_APP_DOMAIN_LP;
            let domainStr = objLP?.custom_domain?.domain || null;
            if (!domainStr && objLP?.custom_domain_id && this.listCustomDomains.length) {
                const found = this.listCustomDomains.find((d) => d.id === objLP.custom_domain_id);
                if (found) domainStr = found.domain;
            }
            const domain = domainStr || domainLP;
            return `https://${domain}/landing-page/${objLP.url_public}`;
        },

        getLpPublishedUrl(objLP) {
            const domainLP = process.env.VUE_APP_DOMAIN_LP;
            let domainStr = objLP?.custom_domain?.domain || null;
            if (objLP?.published_domain) {
                domainStr = objLP.published_domain;
            } else {
                if (!domainStr && objLP?.custom_domain_id && this.listCustomDomains.length) {
                    const found = this.listCustomDomains.find((d) => d.id === objLP.custom_domain_id);
                    if (found) domainStr = found.domain;
                }
            }
            const domain = domainStr || domainLP;
            return `https://${domain}/landing-page/${objLP.url_public}`;
        },

        onHandlePublicPage(objLP) {
            window.open(this.getLpPublishedUrl(objLP), '_blank');
        },

        handleShowFilter() {
            this.checkShowFilter = !this.checkShowFilter;
            this.configKeyword.arrayTag = [];
            this.formSearch = initFormSearch();
        },

        formatDateCommon(date, type) {
            return formatDateCommon(date, type);
        },

        handleStatus(status) {
            if (!status) return '';
            return STATUS_SETTING_BASIC.find((s) => s.id == status)?.value ?? '';
        },

        onChange() {
            this.configPage.page = 1;
            this.getList();
        },

        handleChangePage() {
            this.getList();
        },

        async onGetListCustomDomain() {
            try {
                const response = await this.getListCustomDomain('limit=1000');
                if (response?.data) {
                    this.listCustomDomains = response.data;
                }
            } catch (error) {
                console.log('error', error);
            }
        }
    },
    mounted() {
        this.getList();
        this.getListCommonUser();
        this.onGetListCustomDomain();
    }
};
</script>

<style lang="scss" scoped>
.list-landingpage {
    .grid-container {
        display: grid;
        grid-gap: 16px;
        grid-template-columns: repeat(1, 1fr);
        .grid-item {
            min-width: 180px;
        }

        @media (min-width: 736px) {
            grid-template-columns: repeat(2, 1fr);
        }
        @media (min-width: 900px) {
            grid-template-columns: repeat(3, 1fr);
        }
        @media (min-width: 1124px) {
            grid-template-columns: repeat(4, 1fr);
        }
        @media (min-width: 1400px) {
            grid-template-columns: repeat(5, 1fr);
        }
    }

    .card {
        /* padding-top: 1rem; */
        &.box-lp {
            box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
            transition: all 0.35s;
            &:hover {
                box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 10px;
            }
            .first__view {
                height: 20rem;
                overflow: hidden;
            }
        }
    }
}
</style>
